export class StringUtils {
    static toPascalCase = (input: string): string => {
        // Remove leading and trailing whitespace and split words by whitespace or hyphens
        const words = input.trim().split(/[\s-]+/);

        // Convert each word to PascalCase
        const pascalCaseWords = words.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });

        // Join the words without any separators
        return pascalCaseWords.join('');
    }
}